// extracted by css-extract-rspack-plugin
export default {"progress":"progress-JGbvz6"};